import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card';
import { PimLink } from '@/features/shared/pim-link';
import { SupplierHoverCard } from '@/features/shared/supplier-hover-card';
import { useGetPurchaseOrder } from '@/services/apis/queries/purchase-order/use-get-purchase-order';

type PurchaseOrderMainSupplierProps = {
  purchaseOrderId: string;
};

export function PurchaseOrderMainSupplier({
  purchaseOrderId,
}: PurchaseOrderMainSupplierProps) {
  const { t } = useTranslation('purchaseOrder');

  const { data: purchaseOrder } = useGetPurchaseOrder(purchaseOrderId);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('cardSupplierInformation')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className='flex justify-between'>
          <SupplierHoverCard
            className='text-base'
            key={purchaseOrder.supplier.id}
            supplier={purchaseOrder.supplier}
          />
          <PimLink
            href={`/suppliers/${purchaseOrder.supplier.id}`}
            iconSize={6}
          />
        </div>
      </CardContent>
      <CardHeader>
        <CardTitle>{t('cardSupplierComment')}</CardTitle>
      </CardHeader>
      <CardContent className='text-sm'>
        {purchaseOrder.supplier.comment ? (
          <HoverCard>
            <div className='flex items-center gap-1'>
              <HoverCardTrigger asChild onClick={(e) => e.stopPropagation()}>
                <p className='cursor-pointer truncate hover:underline'>
                  {purchaseOrder.supplier.comment}
                </p>
              </HoverCardTrigger>
            </div>
            <HoverCardContent
              align='start'
              className='w-100 whitespace-pre-line'
            >
              {purchaseOrder.supplier.comment}
            </HoverCardContent>
          </HoverCard>
        ) : (
          <div className='text-muted-foreground text-sm'>{t('noComment')}</div>
        )}
      </CardContent>
    </Card>
  );
}
